import { IBid, ICarrierApplication, IUser, Maybe, ICarrierBidSourceTypes } from 'types/graphqlTypes'

// This is a temporary type -- it will be replaced with the GQL fragment in a later PR
export type ICarrierOption = Pick<
  IBid,
  'id' | 'createdAt' | 'amount' | 'direction' | 'status' | 'acceptedAt'
> & {
  carrierApplication: Pick<ICarrierApplication, 'id' | 'state'>
} & { createdBy: Pick<IUser, 'fullName'> } & {
  acceptedBy: Maybe<Pick<IUser, 'fullName'>>
  source: ICarrierBidSourceTypes
  declinedReason: Maybe<String>
}

export const CARRIER_SOURCE_LABELS: Record<ICarrierBidSourceTypes, string> = {
  [ICarrierBidSourceTypes.alert]: 'Alert',
  [ICarrierBidSourceTypes.auto]: 'Auto',
  [ICarrierBidSourceTypes.covered]: 'Covered',
  [ICarrierBidSourceTypes.fleet_planner]: 'Web',
  [ICarrierBidSourceTypes.manual]: 'Manual',
  [ICarrierBidSourceTypes.marketplace]: 'Marketplace',
  [ICarrierBidSourceTypes.mobile]: 'Mobile',
  [ICarrierBidSourceTypes.offered]: 'Offered',
  [ICarrierBidSourceTypes.push_notification]: 'Push Notification',
}
